import { render, staticRenderFns } from "./ItemSearchUser.vue?vue&type=template&id=24857c66"
import script from "./ItemSearchUser.vue?vue&type=script&lang=js"
export * from "./ItemSearchUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports